import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./core/guards/auth-guard.service";
import { EmptyRouteComponent } from "./empty-route/empty-route.component";
import { CloseDetailsGuard } from "@core/guards/close-details.guard";
import { LoginComponent } from "./login/login.component";

const APP_ROUTES: Routes = [
  {
    path: "login",
    component: LoginComponent
  },
  {
    path: "smartfleet/public",
    loadChildren: () =>
      import("./modules/public/public.module").then((m) => m.PublicModule)
  },
  {
    path: "parts-module",
    canLoad: [AuthGuard],
    loadChildren: () =>
      import("./modules/private-parts/private.module").then(
        (m) => m.PrivateModule
      )
  },
  {
    path: "sales-module",
    canLoad: [AuthGuard],
    loadChildren: () =>
      import("./modules/private-sales/private.module").then(
        (m) => m.PrivateModule
      )
  },
  {
    path: "",
    canLoad: [AuthGuard],
    loadChildren: () =>
      import("./modules/private/private.module").then((m) => m.PrivateModule)
  },
  {
    path: "**",
    component: EmptyRouteComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(APP_ROUTES, { useHash: false })],
  exports: [RouterModule],
  providers: [CloseDetailsGuard]
})
export class AppRoutingModule {}
